import { render, staticRenderFns } from "./BadgeCarousel.vue?vue&type=template&id=7a24ba2b&scoped=true&"
import script from "./BadgeCarousel.vue?vue&type=script&lang=ts&"
export * from "./BadgeCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeCarousel.vue?vue&type=style&index=0&id=7a24ba2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24ba2b",
  null
  
)

export default component.exports